import {combineReducers} from 'redux';
import projectsReducer from "./components/project/projects/projectsReducer";
import projectReducer from "./components/project/one-project/projectReducer";
import usersReducer from "./components/user/reducers/usersReducer";
import currentUserReducer from "./components/user/reducers/currentUserReducer";
import actionReducer from "./components/action/actionReducer";
import actWithTeamReducer from "./components/team/act-with-team/ActWithTeamReducer";
import sendNotificationReducer from "./components/set-date/setDateReducer";
import axisReducer from "./components/axis/all-axis/axisReducer";
import oneAxisReducer from "./components/axis/one-axis/oneAxisReducer";
import oneStakeReducer from "./components/stake/reducers/stakeReducer";
import oneSwotIemReducer from "./components/swot/one-swot-item/SwotItemReducer";
import authReducer from "./components/auth/reducers/authReducer";
import messageReducer from "./components/message/reducers/messageReducer";
import projectHistoryReducer from "./components/history/project-history/projectHistoryReducer";
import userHistoryReducer from "./components/history/user-history/userHistoryReducer";
import strategyReducer from "./components/strategy/strategyReducer";
import stakesReducer from "./components/stake/reducers/stakesReducer";
import boardMembersReducer from "./components/user/boardMember/boardMemberReducer";
import ambassadorsReducer from "./components/user/ambassador/ambassadorsReducer";
import tagCategoryReducer from "./components/tag/tagCategory/tagCategoryReducer";
import tagCategoriesReducer from "./components/tag/tagCategory/tagCategoriesReducer";
import tagReducer from "./components/tag/subTag/tagsReducer";
import oneUserReducer from "./components/user/reducers/oneUserReducer";
import actionsReducer from "./components/action/actionsReducer";
import deletedProjectsReducer from "./components/project/projectsDeletedReducer";
import logsReducer from "./components/log/logReducer";
import contributionsReducer from "./components/kanban/contributionsReducer";
import linksReducer from "./components/link/linksReducer";
import allObjectivesReducer from "./components/objective/allObjectivesReducer";
import okrReducer from './components/objective/ObjectiveReducer'
import indicatorReducer from "./components/indicator/indicatorReducer";
import gantProjectsReducer from "./components/gantt/projects/ganttProjectsReducer";
import ganttProjectReducer from "./components/gantt/project/ganttProjectReducer";

const rootReducer = combineReducers({
    auth: authReducer,
    currentUser: currentUserReducer,
    oneUser: oneUserReducer,
    userHistory: userHistoryReducer,
    projects: projectsReducer,
    ganttProjects: gantProjectsReducer,
    project: projectReducer,
    ganttProject: ganttProjectReducer,
    deletedProjects: deletedProjectsReducer,
    users: usersReducer,
    boardMembers: boardMembersReducer,
    ambassadors: ambassadorsReducer,
    objective: okrReducer,
    objectives: allObjectivesReducer,
    indicator: indicatorReducer,
    tagCategories: tagCategoriesReducer,
    tagCategory: tagCategoryReducer,
    tag: tagReducer,
    link: linksReducer,
    actions: actionsReducer,
    action: actionReducer,
    strategy: strategyReducer,
    axis: axisReducer,
    oneAxis: oneAxisReducer,
    stakes: stakesReducer,
    oneStake: oneStakeReducer,
    oneSwotItem: oneSwotIemReducer,
    projectHistory: projectHistoryReducer,
    sendNotification: sendNotificationReducer,
    contributions: contributionsReducer,
    actWithTeam: actWithTeamReducer,
    logs: logsReducer,
    message: messageReducer,
})

export default rootReducer;